import { styled } from 'styled-components';
"use strict";
const Container = styled.div`
  position: relative;
`;
const InterSectionObserverObject = styled.div`
  position: absolute;
  top: 25%;
  height: 50vh;
  width: 100%;
  pointer-events: none;
`;
export { Container, InterSectionObserverObject };
//# sourceMappingURL=ModelCompareV4.styles.mjs.map
